import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";

import Imagen1 from "../../../images/modulo12/persona1.png";
import Imagen2 from "../../../images/modulo12/02 Walter Talancha.png";
import Imagen3 from "../../../images/modulo12/03 Mónica Quevedo.png";
import Imagen4 from "../../../images/modulo12/04 Johnny Fuller.png";
import Imagen5 from "../../../images/modulo12/05 Juana Lay - Gabriel Chu.png";
import Imagen6 from "../../../images/modulo12/06 Jailer Tuanama.png";
import Imagen7 from "../../../images/modulo12/07 Alejandrina Canchari.png";
import Imagen8 from "../../../images/modulo12/08 Brayan López.png";
import Imagen9 from "../../../images/modulo12/09 María Luisa Carreño.png";
import Imagen10 from "../../../images/modulo12/10 Syndi Sangama.png";
import Imagen11 from "../../../images/modulo12/11 Cusi Yupanqui.png";
import Imagen12 from "../../../images/modulo12/12 Olga Quispe.png";
import Imagen13 from "../../../images/modulo12/13 Pepe Murakami.png";
import Imagen14 from "../../../images/modulo12/14 Tito Cahuana.png";
import Imagen15 from "../../../images/modulo12/15 Inés Orbegoso.png";
import Imagen16 from "../../../images/modulo12/16 Mario Rossi.png";
import Imagen17 from "../../../images/modulo12/17 Benito Guadalupe.png";
import Imagen18 from "../../../images/modulo12/18 Elmer Puémape.png";
import Imagen19 from "../../../images/modulo12/19 Eli Páucar.png";
import Imagen20 from "../../../images/modulo12/24 Estela Espinal.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad1.mp3";

const Actividad2 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "1" },
    ans5: { value: "", valid: "", correctValue: "1" },
    ans6: { value: "", valid: "", correctValue: "1" },
    ans7: { value: "", valid: "", correctValue: "1" },
    ans8: { value: "", valid: "", correctValue: "1" },
    ans9: { value: "", valid: "", correctValue: "1" },
    ans10: { value: "", valid: "", correctValue: "1" },
    ans11: { value: "", valid: "", correctValue: "1" },
    ans12: { value: "", valid: "", correctValue: "1" },
    ans13: { value: "", valid: "", correctValue: "1" },
    ans14: { value: "", valid: "", correctValue: "1" },
    ans15: { value: "", valid: "", correctValue: "1" },
    ans16: { value: "", valid: "", correctValue: "1" },
    ans17: { value: "", valid: "", correctValue: "1" },
    ans18: { value: "", valid: "", correctValue: "1" },
    ans19: { value: "", valid: "", correctValue: "1" },
    ans20: { value: "", valid: "", correctValue: "1" },
  });

  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[0];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${infoUnidad.name}: ${modulo12.content[0].activities[1].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[1].path}`,
    titlePrev: modulo12.title,
    linkPrev: modulo12.url,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>
      <div>
        <h2 className="mb-5">{infoAct.name}</h2>
        <AudioPlayer track={Audio} />
      </div>

      <ul>
        <li>Observa a las personas.</li>
        <li>Responde, ¿quiénes son peruanos? Márcalos con un check.</li>
      </ul>

      <div className="row align-items-end g-5 grupo-peruanos">
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen1} className="img-fluid img-80" alt="Peruanos" />
          <div>
            María
            <br /> García
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans1.valid}
            type="checkbox"
            value="1"
            checked={answers.ans1.value === "1"}
            onChange={(event) => handleAnswers(event, "ans1")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          <div>Walter Talancha</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans2.valid}
            type="checkbox"
            value="1"
            checked={answers.ans2.value === "1"}
            onChange={(event) => handleAnswers(event, "ans2")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen3} className="img-fluid" alt="Peruanos" />
          <div>Mónica Quevedo</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans3.valid}
            type="checkbox"
            value="1"
            checked={answers.ans3.value === "1"}
            onChange={(event) => handleAnswers(event, "ans3")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen4} className="img-fluid" alt="Peruanos" />
          <div>
            Johnny
            <br /> Fuller
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans4.valid}
            type="checkbox"
            value="1"
            checked={answers.ans4.value === "1"}
            onChange={(event) => handleAnswers(event, "ans4")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen5} className="img-fluid" alt="Peruanos" />
          <div>Juana Lay y Gabriel Chu</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans5.valid}
            type="checkbox"
            value="1"
            checked={answers.ans5.value === "1"}
            onChange={(event) => handleAnswers(event, "ans5")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen6} className="img-fluid img-80" alt="Peruanos" />
          <div>Jailer Tuanama</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans6.valid}
            type="checkbox"
            value="1"
            checked={answers.ans6.value === "1"}
            onChange={(event) => handleAnswers(event, "ans6")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen7} className="img-fluid" alt="Peruanos" />
          <div>Alejandrina Canchari</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans7.valid}
            type="checkbox"
            value="1"
            checked={answers.ans7.value === "1"}
            onChange={(event) => handleAnswers(event, "ans7")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen8} className="img-fluid img-80" alt="Peruanos" />
          <div>
            Brayan
            <br /> López
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans8.valid}
            type="checkbox"
            value="1"
            checked={answers.ans8.value === "1"}
            onChange={(event) => handleAnswers(event, "ans8")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen9} className="img-fluid img-80" alt="Peruanos" />
          <div>Syndi Sangama</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans9.valid}
            type="checkbox"
            value="1"
            checked={answers.ans9.value === "1"}
            onChange={(event) => handleAnswers(event, "ans9")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen10} className="img-fluid" alt="Peruanos" />
          <div>María Luisa Carreño</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans10.valid}
            type="checkbox"
            value="1"
            checked={answers.ans10.value === "1"}
            onChange={(event) => handleAnswers(event, "ans10")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen11} className="img-fluid" alt="Peruanos" />
          <div>
            Tito
            <br /> Yupanqui
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans11.valid}
            type="checkbox"
            value="1"
            checked={answers.ans11.value === "1"}
            onChange={(event) => handleAnswers(event, "ans11")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen12} className="img-fluid" alt="Peruanos" />
          <div>
            Olga
            <br /> Quispe
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans12.valid}
            type="checkbox"
            value="1"
            checked={answers.ans12.value === "1"}
            onChange={(event) => handleAnswers(event, "ans12")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen13} className="img-fluid" alt="Peruanos" />
          <div>Pepe Murakami</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans13.valid}
            type="checkbox"
            value="1"
            checked={answers.ans13.value === "1"}
            onChange={(event) => handleAnswers(event, "ans13")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen14} className="img-fluid" alt="Peruanos" />
          <div>
            José
            <br /> Cahuana
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans14.valid}
            type="checkbox"
            value="1"
            checked={answers.ans14.value === "1"}
            onChange={(event) => handleAnswers(event, "ans14")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen15} className="img-fluid" alt="Peruanos" />
          <div>
            Inés
            <br /> Orbegoso
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans15.valid}
            type="checkbox"
            value="1"
            checked={answers.ans15.value === "1"}
            onChange={(event) => handleAnswers(event, "ans15")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen16} className="img-fluid img-80" alt="Peruanos" />
          <div>
            Mario
            <br /> Rossi
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans16.valid}
            type="checkbox"
            value="1"
            checked={answers.ans16.value === "1"}
            onChange={(event) => handleAnswers(event, "ans16")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen17} className="img-fluid" alt="Peruanos" />
          <div>
            Benito
            <br /> Guadalupe
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans17.valid}
            type="checkbox"
            value="1"
            checked={answers.ans17.value === "1"}
            onChange={(event) => handleAnswers(event, "ans17")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen18} className="img-fluid" alt="Peruanos" />
          <div>Elmer Puémape</div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans18.valid}
            type="checkbox"
            value="1"
            checked={answers.ans18.value === "1"}
            onChange={(event) => handleAnswers(event, "ans18")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen19} className="img-fluid img-80" alt="Peruanos" />
          <div>
            Eli
            <br /> Páucar
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans19.valid}
            type="checkbox"
            value="1"
            checked={answers.ans19.value === "1"}
            onChange={(event) => handleAnswers(event, "ans19")}
          />
        </div>
        <div className="col-lg-2 col-md-3  col-4 text-center">
          <img src={Imagen20} className="img-fluid" alt="Peruanos" />
          <div>
            Estela
            <br /> Espinal
          </div>
          <input
            className={"form-check-input mb-1 form-md " + answers.ans20.valid}
            type="checkbox"
            value="1"
            checked={answers.ans20.value === "1"}
            onChange={(event) => handleAnswers(event, "ans20")}
          />
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo12.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <ul className="mt-5">
        <li>Ahora reflexiona: ¿por qué marcaste los que marcaste?</li>
        <textarea className="form-control mb-4" rows={3} />
        <li>
          Ahora toma una hoja de papel. Dibújate y escribe tu nombre en ella.
        </li>
      </ul>
      <p>Escribe tu nombre aquí:</p>
      <input type="text" className="form-control w-200" />
      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Observa a las personas. Pida que, en
            silencio, observen cada una de las personas que aparecen en las
            imágenes. Diga que se detengan en las características de cada una de
            las personas y que reflexionen acerca de sus diferencias.
          </li>
          <li>
            Escoja algunos personajes, apunten sus nombres y pida que los
            describan. Anoten sus respuestas. Por ejemplo:
            <ul>
              <li>
                <i>
                  "¿Cómo es Jailer Tuanama? Es un niño. Su ropa nos indica que
                  viene de un lugar caluroso. Probablemente vaya a la escuela".
                </i>
              </li>
              <li>
                <i>
                  "¿Cómo es Estela Espinal? Es una señora que parece estar
                  embarazada. Tiene un maletín, probablemente es una profesional
                  que trabaja en alguna empresa."
                </i>
              </li>
            </ul>
          </li>

          <li>
            Resalte, de manera general, las diferencias entre las personas. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  "Los personajes que vemos son diversos. Algunos son niñas o
                  niños, otros son adultos. Algunos parecen mayores que otros.
                  También se diferencian por sus rasgos, color de piel,
                  contextura. Sus ropas también nos indican algunas
                  características. Por ejemplo, la vestimenta de Alejandrina
                  Canchari nos dice que viene de algún lugar de la sierra. En el
                  caso de Benito Guadalupe, su ropa indica que es un doctor."
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la segunda indicación: Responde, ¿quiénes son peruanos? Márcalos
            con un check. Deténgase en cada uno de los personajes y pregunte de
            manera oral. Por ejemplo:
            <ul>
              <li>
                <i>"¿María García será peruana?"</i>
              </li>
            </ul>
          </li>

          <li>
            Para cada persona, pida que expliquen por qué piensan que es peruana
            o que no lo es.
          </li>
          <li>
            Señale, a modo de cierre de la actividad, lo siguiente:
            <ul>
              <li>
                <i>
                  "Todos los personajes que observamos son peruanos o peruanas.
                  Como podemos notar, todos somos diferentes pues tenemos
                  características particulares que nos distinguen. En resumen,
                  los peruanos y peruanas nos caracterizamos por ser muy
                  diversos."
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: Ahora toma una hoja de papel. Dibújate
            y escribe tu nombre en ella. Recuerde que deben incluir los rasgos
            que los distinguen y su ropa favorita, Además, deben escribir su
            nombre.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
